import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import post from './post'
import event from './event'
import app from './app'
import tag from './tag'
import category from './category'
import file from './file'
import settings from './settings'
import popularPost from './post-popular'
import user from './user'
import chats from './chats'
import resources from './resources'
import forum from './forum'
import directory from './directory'
import profile from './profile'
import list from './list'
import rss from './rss'
import advertisement from './advertisement'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		auth,
		post,
		event,
		app,
		tag,
		category,
		file,
		settings,
		popularPost,
		user,
		chats,
		forum,
		directory,
		resources,
		profile,
		list,
		rss,
		advertisement
	},
})

export default store
